import React from 'react';
import { useTranslation } from 'react-i18next';

import { PanoramaSphere } from '../../../../../viewer/elements/panorama/panorama-sphere';
import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { SceneManager } from '../../../../../viewer/scene-manager';
import { SkyviewPanoramaScene } from '../../../../../viewer/scenes/skyview-panorama-scene';
import { Orient360PoiTowardsNorthTool } from '../../../../../viewer/tools/orient-360-poi-towards-north';
import { useNonce } from '../../../../hooks/use-nonce';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../tool-icon';

const Rotate360PoiTowardsNorthToolIcon = () => {
  const { t } = useTranslation();
  const { activeScene } = React.useContext(SkyviewContext);
  const [_, refresh] = useNonce();

  useSubscribe(SubscriptionTopic.NewSelection, refresh);
  useSubscribe(SubscriptionTopic.SetTool, refresh);

  let activePanoramaSphere: PanoramaSphere | undefined;
  const panoramaScene = SceneManager.instance.getActiveScene();
  if (panoramaScene instanceof SkyviewPanoramaScene) {
    activePanoramaSphere = panoramaScene.panoramaManager.getPanoramaSphere();
  }

  const activePoi = activePanoramaSphere?.getActivePoi();

  const canRotatePoi = Boolean(activePoi?.is360Poi() && !activePoi?.has360RotationMetadata);
  return (
    <ToolIcon
      active={
        activeScene === 'panoramaViewer' &&
        InputHandler.instance.currentTool()?.name === 'rotate-360-poi-north'
      }
      callback={() => {
        InputHandler.instance.setTool('rotate-360-poi-north');
        const currentTool = InputHandler.instance.currentTool() as Orient360PoiTowardsNorthTool;
        currentTool.getActivePanoramaSphere = () => {
          const panoramaScene = SceneManager.instance.getActiveScene();
          return panoramaScene instanceof SkyviewPanoramaScene
            ? panoramaScene.panoramaManager.getPanoramaSphere()
            : undefined;
        };
      }}
      disabled={activeScene !== 'panoramaViewer' || !canRotatePoi}
      icon={['fal', 'compass-drafting']}
      tooltip={{
        title: t('rotate360Poi.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('rotate360Poi.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { Rotate360PoiTowardsNorthToolIcon };
